module.exports = __webpack_public_path__ + "static/6-dca0ab577c61a5c9027997f2f3ddf50c.png";